import { render } from "./thunt-modal-message-two-buttons.vue?vue&type=template&id=0b756927"
import script from "./thunt-modal-message-two-buttons.vue?vue&type=script&lang=js"
export * from "./thunt-modal-message-two-buttons.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Programmazione\\Nodejs\\CallER\\webapp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__